/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  actions for ProConData module
 */

import type { ProConData } from '@zcode/state-type'
import { createAction } from 'redux-actions'

import {
  CLEAR_PRO_CON_DATA,
  DONE_FETCHING_PRO_CON_DATA,
  ERROR_FETCHING_PRO_CON_DATA,
  RECEIVE_PRO_CON_DATA,
  START_FETCHING_PRO_CON_DATA,
} from '../constants/index'

interface Key {
  key: `${'a' | 'b'}-${number}`
}

export const clearProConData = createAction(CLEAR_PRO_CON_DATA)
export const doneFetchingProConData = createAction<Key, typeof DONE_FETCHING_PRO_CON_DATA>(
  DONE_FETCHING_PRO_CON_DATA
)
export const errorFetchingProConData = createAction<unknown, typeof ERROR_FETCHING_PRO_CON_DATA>(
  ERROR_FETCHING_PRO_CON_DATA
)
export const receiveProConData = createAction<ProConData, typeof RECEIVE_PRO_CON_DATA>(
  RECEIVE_PRO_CON_DATA
)
export const startFetchingProConData = createAction<Key, typeof START_FETCHING_PRO_CON_DATA>(
  START_FETCHING_PRO_CON_DATA
)
